export default __webpack_public_path__ + "static/media/Switch.722458fb.png";